import React from 'react';

const styles = {
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0a',
    zIndex: 9999,
  },
  spinner: {
    width: 36,
    height: 36,
    border: '3px solid rgba(237, 215, 20, 0.15)',
    borderTopColor: '#edd714',
    borderRadius: '50%',
    animation: 'al-spin 0.8s linear infinite',
  },
};

// Inject the keyframe animation once
if (typeof document !== 'undefined' && !document.getElementById('al-loading-keyframes')) {
  const style = document.createElement('style');
  style.id = 'al-loading-keyframes';
  style.textContent = '@keyframes al-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}

export default function LoadingScreen() {
  return (
    <div style={styles.root}>
      <div style={styles.spinner} />
    </div>
  );
}
